export default function TabMaterials() {
  return (
    <div className="dashboard-tab">
      <h3>Materials</h3>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ab earum
        eligendi, saepe, eos porro beatae provident soluta maiores, sed expedita
        deleniti quis quia distinctio officiis eum doloribus voluptates? Nemo,
        eaque.
      </p>
    </div>
  );
}
